import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutoRenewal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.125 4.59375C13.125 4.97656 12.8242 5.25 12.4688 5.25H9.40625H8.53125C8.14844 5.25 7.875 4.97656 7.875 4.59375C7.875 4.23828 8.14844 3.9375 8.53125 3.9375H9.40625H10.8828L9.46094 2.51562C8.66797 1.75 7.62891 1.3125 6.5625 1.3125C4.56641 1.3125 2.84375 2.54297 2.13281 4.26562C1.96875 4.59375 1.58594 4.73047 1.25781 4.59375C0.929688 4.45703 0.765625 4.07422 0.902344 3.74609C1.83203 1.55859 4.01953 0 6.5625 0C7.98438 0 9.35156 0.574219 10.3633 1.58594L11.8125 3.03516V1.53125V0.65625C11.8125 0.300781 12.0859 0 12.4688 0C12.8242 0 13.125 0.300781 13.125 0.65625V4.59375ZM0.65625 7H3.71875C4.07422 7 4.375 7.30078 4.375 7.65625C4.375 8.03906 4.07422 8.3125 3.71875 8.3125H2.21484L3.66406 9.76172C4.42969 10.5273 5.46875 10.9375 6.5625 10.9375C8.53125 10.9375 10.2539 9.76172 10.9648 8.03906C11.1289 7.68359 11.5117 7.54688 11.8398 7.68359C12.168 7.82031 12.332 8.20312 12.1953 8.55859C11.2383 10.7188 9.07812 12.25 6.5625 12.25C5.11328 12.25 3.74609 11.7031 2.73438 10.6914L1.3125 9.24219V10.7188C1.3125 11.1016 1.01172 11.375 0.65625 11.375C0.273438 11.375 0 11.1016 0 10.7188V7.65625C0 7.30078 0.273438 7 0.65625 7Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgAutoRenewal);
export { ForwardRef as ReactComponent };
